// extracted by mini-css-extract-plugin
export default {"contents":"style_contents__X+c59","error":"style_error__Sq1UU"};